import "./LanguageSelector.css";
import SlMenuItem from "@shoelace-style/shoelace/dist/react/menu-item";
import SlMenuLabel from "@shoelace-style/shoelace/dist/react/menu-label";
import SlDivider from "@shoelace-style/shoelace/dist/react/divider";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner";
import { Language, useTranslation } from "../../contexts/TranslationContext";

const OPTIONS: { value: Language; label: string }[] = [
  { value: "es", label: "Español" },
  { value: "en", label: "English" },
];

export const LanguageSelector = () => {
  const { lang, status, enabled, setLang } = useTranslation();

  if (!enabled) return null;

  return (
    <>
      <SlMenuLabel>
        <span className="language-selector-label">
          Idioma
          {status === "downloading" && <SlSpinner className="language-selector-spinner"></SlSpinner>}
        </span>
      </SlMenuLabel>
      {OPTIONS.map((option) => (
        <SlMenuItem
          key={option.value}
          disabled={status === "unsupported" && option.value === "en"}
          onClick={() => setLang(option.value)}
        >
          <span className="menu-item">{option.label}</span>
          {lang === option.value && <SlIcon slot="suffix" name="check-lg"></SlIcon>}
        </SlMenuItem>
      ))}
      <SlDivider></SlDivider>
    </>
  );
};

export default LanguageSelector;
